var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMentalFunctionsSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_08",
    "data-name": 8,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solution_3_",
    "data-name": "solution (3)",
    transform: "translate(506.142 80.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12695",
    "data-name": "Path 12695",
    d: "M69.981,7.736A26.413,26.413,0,0,0,24.891,26.18L20.1,35.758a.978.978,0,0,0,.372,1.276l4.416,2.65V53.8a.978.978,0,0,0,.978.978h8.8v6.848a.978.978,0,0,0,.978.978h31.3a.978.978,0,0,0,.978-.978v-14.7a26.414,26.414,0,0,0,2.047-39.2Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12696",
    "data-name": "Path 12696",
    d: "M148.026,283.936a2.93,2.93,0,0,0-2.33.725V280h-4.661a2.935,2.935,0,1,1-4.374,0H132v12.718a.978.978,0,0,0,.978.978H145.7v-4.661a2.935,2.935,0,1,0,2.33-5.1Z",
    transform: "translate(-98.305 -245.761)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12697",
    "data-name": "Path 12697",
    d: "M133.958,291.739V280H132v12.718a.978.978,0,0,0,.978.978H145.7v-1.956Z",
    transform: "translate(-98.306 -245.761)",
    fill: "#5d68ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12698",
    "data-name": "Path 12698",
    d: "M141.761,184.025a2.93,2.93,0,0,0-.725-2.33H145.7v-4.661a2.935,2.935,0,1,1,0-4.374v-3.927a.734.734,0,0,0-.734-.734H132.979a.978.978,0,0,0-.978.978V181.7h4.661a2.935,2.935,0,1,0,5.1,2.33Z",
    transform: "translate(-98.306 -147.456)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12699",
    "data-name": "Path 12699",
    d: "M134.936,168h-1.957a.978.978,0,0,0-.978.978V181.7h1.957V168.978A.978.978,0,0,1,134.936,168Z",
    transform: "translate(-98.306 -147.456)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12700",
    "data-name": "Path 12700",
    d: "M285.044,85.142a2.93,2.93,0,0,0,1.135-2.16l2.777,2.777a.734.734,0,0,0,1.038,0l2.777-2.777a2.935,2.935,0,1,1,3.093-3.093l2.777-2.777a.734.734,0,0,0,0-1.038L290.166,67.6a.978.978,0,0,0-1.384,0l-8.474,8.474a.734.734,0,0,0,0,1.038l2.777,2.777a2.935,2.935,0,1,0,1.958,5.253Z",
    transform: "translate(-228.289 -59.083)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12701",
    "data-name": "Path 12701",
    d: "M247.936,242.561a2.931,2.931,0,0,0,.725,2.33H244v4.661a2.935,2.935,0,1,1,0,4.374v4.661h12.718a.978.978,0,0,0,.978-.978V245.625a.734.734,0,0,0-.734-.734h-3.927a2.935,2.935,0,1,0-5.1-2.33Z",
    transform: "translate(-196.609 -210.652)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12702",
    "data-name": "Path 12702",
    d: "M256.718,368.978H244v1.956h12.717a.978.978,0,0,0,.978-.978V368A.978.978,0,0,1,256.718,368.978Z",
    transform: "translate(-196.61 -323)",
    fill: "#6a75b9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalFunctionsSmall);
export default __webpack_public_path__ + "static/media/mentalFunctions_small.e007f8076d4c924ce75a70fa828e2b75.svg";
export { ForwardRef as ReactComponent };